// Modules
import { Link } from 'react-router';
import React from 'react';
import _ from 'lodash';

import { ACTIVE_COMPANY_SERVICES, CLIENT_ROLES } from 'constants';
import AgreementLink from 'components/models/agreement/agreement-link';
import CompanyLink from 'components/models/company/company-link';
import SVG from 'components/widgets/icons/svg';
import Tooltip from 'components/widgets/overlays/tooltip';


// Component
export default class CompanyRow extends React.PureComponent {
  render() {
    const { company } = this.props;
    const apps = company.externalAppIds;
    const employees = company.employees;
    const users = _.filter(company.employees, user => _.includes(CLIENT_ROLES, user.role));
    const query = { where: { company: company.id } };
    const invoiceQuery = { where: { company: company.id, paymentStatus: ['Unpaid'] } };

    return (
      <tr>
        <td><CompanyLink company={company} /></td>
        <td><AgreementLink agreement={company.defaultAgreement} /></td>
        <td className="right-align"><Link to={{ pathname: '/people', query }}>{employees.length}</Link></td>
        <td className="right-align"><Link to={{ pathname: '/admin/users', query }}>{users.length}</Link></td>
        <td className="right-align">
          {company.balance > 0 && <Link to={{ pathname: '/accounting/invoices', query: invoiceQuery }}>${company.balance}</Link>}
        </td>
        {_.map(ACTIVE_COMPANY_SERVICES, service =>
          <td className="grid-cell collapse-width" key={service}>
            <Tooltip title={`${_.startCase(service)} ID: ${_.get(apps, service)}`}>
              {_.get(apps, service) &&
                <SVG className="check-icon" src="svg/check.svg" />
              }
            </Tooltip>
          </td>
        )}
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/company/client-row.js